import { BaseService } from '@services/BaseService';
import { CommentViewModel, CommentType } from '@models/Comment';
import { PageViewModel } from '@models/common.models';

class CommentService extends BaseService {
  constructor() {
    super('contract');
  }

  getComment(id: number) {
    return this.fetch<CommentViewModel>(`Comment/${id}`, {
      method: 'GET'
    });
  }

  deleteComment(id: number, type: CommentType) {
    this.apiRoot = CommentType[type];
    return this.fetch(`comments/${id}`, { method: 'DELETE' });
  }

  searchComments(
    entityId: number,
    entityType: CommentType,
    query: string | null,
    pageSize?: number,
    page?: number,
    orderBy?: string,
    orderDirection?: string
  ) {
    this.apiRoot = CommentType[entityType];

    return this.fetch<PageViewModel<CommentViewModel>>(`${this.apiRoot}CommentsSearch`, {
      method: 'POST',
      body: JSON.stringify({
        id: entityId,
        query: query,
        pageSize: pageSize,
        pageNumber: page,
        orderBy: orderBy,
        orderDirection: orderDirection
      })
    });
  }

  async saveComment(entityId: number, entityType: CommentType, model: CommentViewModel): Promise<number> {
    this.apiRoot = this.apiRoot = CommentType[entityType];

    const requestJSON: string = JSON.stringify({ ...model, entityId: entityId });

    if (model.commentId && model.commentId !== 0) {
      await this.fetch(`comments/${model.commentId}`, {
        method: 'PUT',
        body: requestJSON
      });
      return model.commentId;
    }

    return this.fetch<number>('comments', {
      method: 'POST',
      body: requestJSON
    });
  }

  completeComment(id: number, type: CommentType) {
    this.apiRoot = CommentType[type];

    return this.fetch<void>(`comments/${id}/complete`, {
      method: 'PUT'
    });
  }
}

export const commentService = new CommentService();



// WEBPACK FOOTER //
// ./src/_services/CommentService.ts